export class NumericInputDialogViewModel
{
    id: string | null = null;

    title: string = "Set numeric value";

    value: number | null = null;
    minValue: number | null = null;
    maxValue: number | null = null;
    label: string | null = null;
    description: string | null = null;
    step: number = 0.01;

    valueRequired: boolean = false;

    showValueRange: boolean = true;

    isOpened: boolean = false;

    opener: any = null;

    show()
    {
        this.isOpened = true;
    }

    close()
    {
        this.isOpened = false;
    }
}